import React, { Suspense, lazy } from 'react';

import dayjs from 'dayjs';
import { Router, Route } from 'react-router-dom';
import { QueryParamProvider } from 'use-query-params';
import LocalizedFormat from 'dayjs/plugin/localizedFormat';

import Public from 'Public';
import history from 'setup/history';
import { useAuth } from 'modules/partial/hooks';
import { AUTH_TYPE } from 'modules/partial/constants';
import {
  ModalMarker as ModalMarkerV2,
  AlertMarker as AlertMarkerV2,
  LightBoxMarker as LightBoxMarkerV2,
  ToastMarker as ToastMarkerV2,
  DrawerMarker as DrawerMarkerV2,
} from 'modules/common';
import ScreenLoader from 'modules/common/components/ScreenLoader';
import ErrorBoundary from 'modules/common/components/ErrorBoundary';
import TokenWatcher from 'modules/partial/containers/TokenWatcher';
import ToastMarker from 'modules/common/toast';
import { DrawerMarker } from 'modules/common/drawer';
import { ModalMarker, AlertMarker, LightBoxMarker } from 'modules/common/modal';

dayjs.extend(LocalizedFormat);

const Private = lazy(() => import('./Private'));

function App() {
  const [isAppReady, isAuthenticated, authType] = useAuth();

  if (!isAppReady && !authType) return <ScreenLoader />;

  return (
    <ErrorBoundary>
      <LightBoxMarker />
      <AlertMarker />
      <ModalMarker />
      <ToastMarker />
      <DrawerMarker />
      <LightBoxMarkerV2 />
      <AlertMarkerV2 />
      <ModalMarkerV2 />
      <ToastMarkerV2 />
      <DrawerMarkerV2 />

      <AUTH_TYPE.Provider value={authType}>
        <TokenWatcher>
          <Router history={history}>
            <QueryParamProvider ReactRouterRoute={Route}>
              {isAuthenticated ? (
                <Suspense fallback={<ScreenLoader />}>
                  <Private />
                </Suspense>
              ) : (
                <Public />
              )}
            </QueryParamProvider>
          </Router>
        </TokenWatcher>
      </AUTH_TYPE.Provider>
    </ErrorBoundary>
  );
}

export default App;
